import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import translate from '../../other/translate.json';
import clsx from 'clsx';
import config from '../../other/config';
import utils from '../../other/utils'
import FavoritesIcon from '../../icons/FavoritesIcon';
import { Tooltip, IconButton } from '@material-ui/core';

const { serverAPI } = config;

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

export default function FavoriteButton(props) {
	const classes = useStyles();
	const { title, onClick, fill, needMarginBottom, backgroundColor } = props

	return (
		<CustomTooltip placement="bottom" title={title}>
			<IconButton aria-label="share" className={needMarginBottom === true ? classes.iconmb : classes.icon} onClick={onClick} style={{ backgroundColor, boxShadow: props.boxShadow ? '4px 4px 20px rgba(68, 113, 209, 0.12)' : undefined }} >
				<FavoritesIcon fill={fill} />
			</IconButton>
		</CustomTooltip>
	);
}

const useStyles = makeStyles((theme) => ({
	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		// '&:first-child': {
		// 	marginLeft: 'auto',
		// }
	},
	iconmb: {
		marginBottom: 12,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		// '&:first-child': {
		// 	marginLeft: 'auto',
		// }
	}
}));